import { render, staticRenderFns } from "./MMP_ExpandableDisplay.vue?vue&type=template&id=573db45e&scoped=true&"
import script from "./MMP_ExpandableDisplay.vue?vue&type=script&lang=js&"
export * from "./MMP_ExpandableDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MMP_ExpandableDisplay.vue?vue&type=style&index=0&id=573db45e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573db45e",
  null
  
)

export default component.exports